<template>
  <div class="lang-page">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        placeholder="请输入域名"
        @keyup.enter.native="getList('status')"
        size="small"
        class="param-input"
        v-model="params.domain"
        clearable
      ></el-input>
      <el-select
        v-model.number="params.user"
        size="small"
        placeholder="请选择用途"
        clearable
        @change="getList('status')"
      >
        <el-option :value="0" label="落地页"></el-option>
        <el-option :value="1" label="商区"></el-option>
      </el-select>
      <el-select
        v-model.number="params.status"
        size="small"
        placeholder="请选择状态"
        clearable
        @change="getList('status')"
      >
        <el-option :value="0" label="正常"></el-option>
        <el-option :value="1" label="微信禁封"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="getList('status')">搜索</el-button>
      <el-button type="primary" size="small" @click="addLandPage('add')">+新增落地页</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column prop="domain" label="域名" align="center" min-width="120" fixed>
        <template slot-scope="scope">
          <a :href="scope.row.domain" target="_blank">{{scope.row.domain}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" min-width="120" fixed>
        <template slot-scope="scope">
          <p
            class="p1"
            :style="colors=(scope.row.status===0)?'background:green;color:#fff':'background:#FF9300;color:#fff'"
          >{{ scope.row.status==0?'正常':' 微信禁封'}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="enable" label="开关" align="center" min-width="100">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.enable" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="uses" label="用途" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.uses === 0 ?'落地页' : '商区'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="weight" label="权重" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.weight}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="描述" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{scope.row.desc || '无'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.remark || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="150">
        <template slot-scope="scope">
          <el-button
            type="success"
            icon="el-icon-edit"
            size="mini"
            @click="addLandPage('edit', scope.row)"
          ></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 25]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <land-page ref="landPage" @handlerLandPage="getList"></land-page>
  </div>
</template>
<script>
import api from "@/api";
import LandPage from "./components/addPopup";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        domain: "",
        user: ""
      }
    };
  },
  components: {
    LandPage
  },
  created() {
    this.getList();
  },

  methods: {
    // 请求落地页配置列表
    getList(type) {
      if (type) {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      api
        .getLangPageList(this.params)
        .then(res => {
          this.loading = false;
          if (res.code === 200 && res.data.list.length > 0) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getList();
    },
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getList();
    },
    addLandPage(type, data) {
      this.$refs.landPage.open(type, data);
    },
    // 删除落地页
    remove(id) {
      this.$confirm("您确定要删除当前配置吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        api.deleteLandPage({ id: id }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    }
  }
};
</script>